<template>
  <div class="loading" v-if="show">
    <img class="loading-gif" src="../../images/pages/activities/loading.gif" alt="">
    加载中
  </div>
</template>

<script>
export default {
  name: 'Loading',
  data() {
    return {
      show: true
    }
  },
  mounted() {
    this.show = true
  },
  methods: {
    closeLoading() {
      this.show = false
    }
  }
}
</script>

<style lang="less" scoped>
  .loading {
    .loading-gif {
      width: .72rem;
      height: .72rem;
      z-index: 999;
    }
  }
</style>